import {useContext} from "react";
import {useLocation, useNavigate} from "react-router";
import {ANIMATION__CONTEXT, Local_Data} from "../../Context";

/** Keep in sync with the wipe in `Pages/Components/Animation`. */
export const TRANSITION_DURATION = 700

const NAVIGATE_AT = 230

const useS115 = () => {

    const [, setIsAnimationOn] = useContext<any>(ANIMATION__CONTEXT)

    const [, setLocalData] = useContext<any>(Local_Data)

    const navigate = useNavigate()

    const location = useLocation()

    const handleAnimation = () => {
        setIsAnimationOn(true)
        setTimeout(() => {
            setIsAnimationOn(false)
        }, TRANSITION_DURATION)
    }

    const closeOverlays = () => {
        setLocalData((state: any) => ({
            ...state,
            isMenuOpen: false,
            isBasketOpen: false,
            isOpenLanguage: false
        }))
    }

    /**
     * Navigates behind the brand wipe. Re-clicking the current page only closes
     * whatever overlay is open instead of replaying the animation.
     */
    const navigatePage = (path: string) => {
        closeOverlays()

        if (path === location.pathname) {
            window.scrollTo({top: 0, behavior: 'smooth'})
            return
        }

        handleAnimation()
        setTimeout(() => {
            window.scrollTo(0, 0)
            navigate(path)
        }, NAVIGATE_AT)
    }

    return ({
        handleAnimation,
        closeOverlays,
        navigatePage
    })
}

export default useS115
